import React, {memo, useContext, useEffect, useState} from 'react';
import MergeGridItem from '../../../../shared/components/mergeBoard/MergeGridItem';
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import ItemStorage from "../../../../shared/components/mergeBoard/ItemStorage";
import MergeInventoryList from "../../../../shared/components/mergeBoard/MergeInventoryList";
import {useMergeBlockMainData} from "../../../logs/useTableData";
import IsLoading from "../../../../shared/components/IsLoading";
import ErrorPage from "../../../../shared/components/ErrorPage";
import {useEventPlatterData} from "../../../probability/useItemData";
import {AuthContext} from "../../../../shared/contexts/authContext";

const MergeGrid = memo(() => {
    const {playerData, setPlayerData} = useContext(PlayerContext);
    const {currentUser} = useContext(AuthContext);

    const blocks = playerData?.playerInfo?.mergeData?.mBlocks || [];
    const {data: mergeMainData, isLoading, error} = useMergeBlockMainData();
    const {data: eventPlatterData, isLoading: isEventPlatterLoading, error: eventPlatterError} = useEventPlatterData();

    const [platterData, setPlatterData] = useState(null);
    const [trayList, setTrayList] = useState(new Set());

    useEffect(() => {
        const filteredList = Object.values(playerData?.playerInfo?.liveEventCache?.LiveEventCaches ?? {})
            .filter(eventCache => eventCache?.EventInfo?.PlatterData?.curTargetSettingIndex > 0);
        if (
            filteredList.length > 0 &&
            filteredList[0]?.EventInfo?.PlatterData &&
            eventPlatterData?.[currentUser?.target]
        ) {
            setPlatterData(filteredList[0].EventInfo.PlatterData);
            const trays = Object.values(eventPlatterData?.[currentUser?.target] || {})
                .filter(platter => platter.index === filteredList[0].EventInfo.PlatterData.curTargetSettingIndex)
                .map(platter => platter.trayIdx);
            setTrayList(new Set(trays));
        }
    }, [eventPlatterData, playerData, currentUser]);

    if (isLoading || isEventPlatterLoading) return <IsLoading/>;
    if (error || eventPlatterError) return <ErrorPage error={error}/>
    console.log(playerData?.playerInfo?.inventoryData?.MergeInventories)
    return (
        <div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%', // 전체 폭을 차지하도록
                maxWidth: '500px', // 최대 너비 제한 유지
                margin: '0 auto', // 중앙 정렬
                position: 'relative', // 자식 absolute 요소들을 위해
            }}>
                <MergeInventoryList
                    mergeInventories={playerData?.playerInfo?.inventoryData?.MergeInventories}
                    mergeMainData={mergeMainData}
                />
                {/*<MergeHeader userInfo={playerData?.playerInfo?.userInfo}*/}
                {/*             walletData={playerData?.playerInfo?.walletData}*/}
                {/*             mergeData={playerData?.playerInfo?.mergeData}*/}
                {/*/>*/}
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(7, 1fr)', // 7열 그리드
                        gap: '2px', // 그리드 셀 사이의 간격을 2px로 줄임
                        width: '100%', // 부모 Flex 컨테이너의 100%를 차지
                        // maxWidth: '500px'는 이미 부모에서 처리됨
                        padding: '5px', // 그리드 전체의 내부 여백도 줄임
                        backgroundColor: '#cceeff',
                        borderRadius: '16px',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                        marginTop: '20px',
                        boxSizing: 'border-box',
                    }}
                >
                    {blocks.flat().map((item, index) => (
                        <MergeGridItem
                            key={item?.MTargetBlock?.slotIndex ?? `empty-${index}`}
                            item={item}
                            mergeMainData={mergeMainData}
                            playerData={playerData}
                            trayList={trayList}
                            platterData={platterData}
                            eventPlatterData={eventPlatterData?.[currentUser?.target]}
                            setPlayerData={setPlayerData}
                        />
                    ))}
                </div>
                {/*<MissionList missionContentsDatas={playerData?.playerInfo?.missionContentsDatas}/>*/}

                <ItemStorage
                    storageItems={playerData?.playerInfo?.mergeData.mStorageData}
                    currentStorageSize={playerData?.playerInfo?.mergeData.mCurStorageSize}
                    mergeMainData={mergeMainData}
                />

            </div>
        </div>
    );
});

export default MergeGrid;